import { render, staticRenderFns } from "./EachCountryFarmerStories.vue?vue&type=template&id=5cd34736&scoped=true&"
import script from "./EachCountryFarmerStories.vue?vue&type=script&lang=js&"
export * from "./EachCountryFarmerStories.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryFarmerStories.vue?vue&type=style&index=0&id=5cd34736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd34736",
  null
  
)

export default component.exports